import Api from '@api/setMealManage'
import { LV_PAI } from '@components/LocalMerchant/SetMealCreate/contants'
import { getLocationQuery } from '@util'
import { message } from 'hljd'
import cloneDeep from 'lodash/cloneDeep'
import { action, observable, toJS } from 'mobx'
import {
  HOTEL_PLANE_VALUE,
  MAN_RING_OPTION,
  WOMAN_RING_OPTION,
  MAN_RING_WITHOUT_DIAMOND,
  WOMAN_RING_WITHOUT_DIAMOND
} from './contants'

export default class {
  constructor(stepTwoStore) {
    this.stepTwoStore = stepTwoStore
    this.centerStore = stepTwoStore.centerStore
  }
  @observable propertyId = null

  // 当前商家类型下所有待选参数
  @observable service = []
  @observable serviceSort = {}
  // 主store 已选的服务参数
  @observable merchandiseParams = {}
  // 主store 获取的数据排序
  @observable selectedParamSort = {}

  @observable weddingPhotoType = '1'

  @observable scenicSpot = [] // 取景地列表

  // 特殊参数
  @observable age_begin = null
  @observable age_end = null

  sourceServiceConfig = [] // 获取到的配置项源数据

  sessionServiceData = {} // 服务内容数据
  sessionServiceSort = {} // 服务内容模块排序数据
  sessionServiceDeleted = {} // 被删除的模块

  form

  /** 获取服务内容需要提交的所有数据 */
  getData = () => {
    const {
      sessionServiceData,
      sessionServiceSort,
      sessionServiceDeleted
    } = this
    return {
      sessionServiceData,
      sessionServiceSort,
      sessionServiceDeleted
    }
  }

  /**
   * 获取服务内容配置项
   * 根据商家分类从接口获取服务内容配置项，并且若当前是「婚纱摄影」或「婚戒首饰」商家，还要根据当前选择的子分类在本地进行筛选
   */
  init = async () => {
    this.propertyId = this.centerStore.property_id

    this.weddingPhotoType = +this.centerStore.weddingPhotoType
    this.jewelryType = +this.centerStore.jewelryType
    this.second_category_id = +this.centerStore.second_category_id
    this.scenicSpot = this.centerStore.scenicSpot

    let service = cloneDeep(toJS(this.sourceServiceConfig))
    // init可能会多次执行(切换服务内容和图文介绍模块，或者切换子类目时)，这里将配置暂存，避免多次请求
    if (!service || !service.length) {
      const { data: newServiceConfig } = await Api.getSetmealServiceConfig({
        property_id: this.propertyId
      })
      this.sourceServiceConfig = cloneDeep(newServiceConfig)

      service = newServiceConfig
    }

    if (!service || !service.length) {
      return message.warning('未知类型商家')
    }

    const isSingle = !!+getLocationQuery('isSingle')
    const gender = +getLocationQuery('gender')
    // 婚纱礼服的单品和套餐略有不同，区分操作
    if (this.propertyId == 12) {
      this.clothingParameters = {
        isSingle,
        gender
      }
      if (isSingle) {
        // 单品， 筛选出单品和符合性别的
        service = service.filter(
          el => el.isSingle === isSingle && el.gender === gender
        )
      } else {
        // 套餐，筛选出套餐
        service = service.filter(el => el.isSingle === isSingle)
      }
    }

    // 婚纱摄影分类子分类筛选
    if (this.propertyId == 6) {
      service = service
        .map(el => {
          el.childNodes = el.childNodes.filter(item =>
            (item.weddingPhototype || []).includes(this.weddingPhotoType)
          )
          return el
        })
        .filter(el => el.childNodes.length)
    }

    const {
      stepTwoData: {
        merchandise_params = {},
        merchandise_params_sort,
        merchandise_params_deleted
      }
    } = this.stepTwoStore

    let disabledConfigKeys = [] // 有些选项选择了特定值后，另外一些选项会被自动隐藏，这里记录需要隐藏的key

    // 找出婚纱摄影中不可填写类目
    if (this.propertyId == 6) {
      const scenes = merchandise_params.scenes
      switch (+scenes) {
        case 27:
          disabledConfigKeys = ['outer_scenes_num', 'outer_scenes_des']
          break

        case 28:
          disabledConfigKeys = ['inner_scenes_num', 'inner_scenes_des']
          break
      }
      // 子类型-旅拍类型时，获取到的酒店的选择值为否的时候，隐藏酒店等级选择
      if (this.weddingPhotoType == LV_PAI) {
        const planeHotelValue =
          service
            .find(s => s.key === 'plane_level')
            ?.childNodes?.findIndex(
              f => f.key === 'plane_hotel' && f.value == HOTEL_PLANE_VALUE
            ) > -1
        const planeHotel = merchandise_params.plane_hotel
        if (planeHotel == HOTEL_PLANE_VALUE) {
          disabledConfigKeys.push('plane_hotel_level')
        } else if (planeHotel == null && planeHotelValue) {
          disabledConfigKeys.push('plane_hotel_level')
        }
      }
    }

    let clothingForceChecked = null
    if (this.propertyId == 12) {
      // 婚纱礼服
      // 婚纱礼服选择了套餐主推(package_push)后，套餐内容(clothing || man_clothing)必须勾选上主推的内容并且不可取消勾选
      const package_push = merchandise_params.package_push
      if (package_push) {
        clothingForceChecked = {
          '410': '212',
          '409': '213',
          '408': '214',
          '407': '215',
          '405': '216',
          '406': '412',
          '583': '582'
        }[package_push]
      }

      const man_package_push = merchandise_params.man_package_push
      if (man_package_push) {
        clothingForceChecked = {
          '594': '597',
          '595': '598',
          '596': '599'
        }[man_package_push]
      }
    }

    // 婚戒参数筛选
    if (this.propertyId == 14) {
      const scenes = merchandise_params.scenes
      const jewelry_type = this.jewelryType // 婚戒子分类
      service = service.filter(el => el.jewelry_type === jewelry_type)
      if (jewelry_type == 3) {
        switch (+scenes) {
          case 874:
          case 352:
          case 824:
            disabledConfigKeys = ['treasure_size']
            break
          case 351:
          case 372:
          case 378:
            disabledConfigKeys = ['treasure_diameter_or_length']
            break
          case 877:
            disabledConfigKeys = [
              'treasure_diamond_weight',
              'treasure_diamond_certificate',
              'treasure_diamond_color',
              'treasure_diamond_pure',
              'treasure_diamond_cut'
            ]
            break
        }
        if (
          merchandise_params.treasure_style == '874' ||
          merchandise_params.treasure_style == '352' ||
          merchandise_params.treasure_style == '824'
        ) {
          disabledConfigKeys = ['treasure_size']
        }
        if (
          merchandise_params.treasure_style == '351' ||
          merchandise_params.treasure_style == '372' ||
          merchandise_params.treasure_style == '378'
        ) {
          disabledConfigKeys = ['treasure_diameter_or_length']
        }
        if (merchandise_params.treasure_diamond == '877') {
          disabledConfigKeys = [
            ...disabledConfigKeys,
            'treasure_diamond_weight',
            'treasure_diamond_certificate',
            'treasure_diamond_color',
            'treasure_diamond_pure',
            'treasure_diamond_cut'
          ]
        }
      } else if (jewelry_type == 2) {
        switch (+scenes) {
          case 330:
            disabledConfigKeys = WOMAN_RING_WITHOUT_DIAMOND
            break
          case 786:
            disabledConfigKeys = MAN_RING_WITHOUT_DIAMOND
            break
          case 753:
            disabledConfigKeys = MAN_RING_OPTION
            break
          case 754:
            disabledConfigKeys = WOMAN_RING_OPTION
        }

        if (merchandise_params.ring_diamond == '330') {
          disabledConfigKeys = WOMAN_RING_WITHOUT_DIAMOND
        }
        if (merchandise_params.ring_man_diamond == '786') {
          disabledConfigKeys = [
            ...disabledConfigKeys,
            ...MAN_RING_WITHOUT_DIAMOND
          ]
        }
        if (merchandise_params.ring_style == '753') {
          disabledConfigKeys = [...disabledConfigKeys, ...MAN_RING_OPTION]
        }
        if (merchandise_params.ring_style == '754') {
          disabledConfigKeys = [...disabledConfigKeys, ...WOMAN_RING_OPTION]
        }
      }
    }

    /**
     * 有二级分类时，筛选出对应展示的选项
     * 由于涉及数据格式时没有考虑子分类字段的通用性，导致婚戒和婚纱摄影是单独处理的
     */
    if (
      !isSingle &&
      this.second_category_id &&
      this.propertyId != 14 &&
      this.propertyId != 6
    ) {
      service = service.filter(
        el =>
          el.secondCategoryId && el.secondCategoryId == this.second_category_id
      )
    }

    // 若是编辑状态，取出服务内容已选值
    this.merchandiseParams = merchandise_params || {}
    this.selectedParamSort = merchandise_params_sort || {}
    this.selectedParamDeleted = merchandise_params_deleted || {} // 商家自行删除的非必填模块(如婚戒首饰-钻戒 里的副钻)
    service.map(el => {
      el.childNodes = el.childNodes.reduce((pre, curr) => {
        if (curr.type === 'inputInterval') {
          // 区间输入框 这里的意思是区间输入框只有年龄？   ??? 为什么要把age_begin和age_end单独拿出来呢
          this.age_begin = this.merchandiseParams['age_begin']
          this.age_end = this.merchandiseParams['age_end']
          pre = [...pre, curr]
          return pre
        }

        // 编辑时取已填的value
        const value = merchandise_params[curr.key]

        // 配置从本地改为接口取值时改了key，这里在入口处格式化一下兼容
        if (curr.type === 'selectInput') {
          curr.placeholder = curr.options[0].placeholder
          curr.options = [...curr.options[0].options]
        }
        if (curr.options) {
          curr.options = curr.options.map(({ value, text }) => {
            if (curr.key === 'radioInput' && !value) {
              value = '-1'
            }
            return {
              id: value,
              title: text
            }
          })
        }
        if (curr.type === 'radioInput') {
          if (curr.value) {
            curr.value = {
              id: curr.value
            }
          }

          // 兼容老数据
          if (value && !value.id) {
            delete merchandise_params[curr.key].id
          }
        }
        pre = [
          ...pre,
          {
            ...curr,
            value:
              value !== undefined
                ? this.checkArrayValue(value, curr.type)
                : this.merchandiseParams[curr.key] || curr.value,
            disabled: disabledConfigKeys.includes(curr.key),
            disabledItem:
              curr.key === 'clothing' || curr.key === 'man_clothing'
                ? clothingForceChecked
                : null,
            unit: curr.unitKey
              ? this.merchandiseParams[curr.unitKey] || curr.unit
              : curr.unit,
            type: curr.key === 'shoot_team' ? 'selectInput' : curr.type
          }
        ]
        // }
        return pre
      }, [])
      return el
    })
    // 排序模块
    // 如果能查找到子元素的value 则按当前值进行分配权重 否则给予999 权重排到最后（用于非必填、子节点也是非必填的情况）
    const serviceSort = service.reduce((pre, curr) => {
      if (curr.childNodes.length > 0) {
        const currNodes = curr.childNodes.find(
          el => this.selectedParamSort[el.key] !== undefined
        )
        pre[curr.key] = currNodes ? +this.selectedParamSort[currNodes.key] : 999
      }
      return pre
    }, {})
    // 被删除的元素
    const selectedParamDeleted = Object.keys(this.selectedParamDeleted || {})
    if (this.weddingPhotoType == 1 || this.weddingPhotoType == LV_PAI) {
      this.handleSceneOptional(service)
    }

    this.service = service
      .sort((a, b) => {
        return serviceSort[a.key] - serviceSort[b.key]
      })
      .map((el, i) => ({
        ...el,
        status: i === 0, // 选中状态，进来后第一个直接被选中
        isShow: !selectedParamDeleted.includes(el.childNodes[0].key) // 是否被删除
      }))

    if (this.propertyId == 14) {
      const jewelry_type = this.jewelryType // 婚戒子分类
      if (jewelry_type == 2) {
        if (merchandise_params.ring_style == '753') {
          this.handleChangeDataNode('男戒', true)
        }
        if (merchandise_params.ring_style == '754') {
          this.handleChangeDataNode('女戒', true)
        }
      }
    }

    console.log('data', service)

    this.save()
  }

  handleSceneOptional = service => {
    let newScenes
    if (this.centerStore.detailData.merchandise_params) {
      const {
        merchandise_params: { scenes }
      } = toJS(this.centerStore.detailData)
      newScenes = this.form
        ? this.form.getFieldValue('scenes') || scenes
        : scenes
    } else {
      newScenes = this.form ? this.form.getFieldValue('scenes') : ''
    }

    if (this.weddingPhotoType == 1 && toJS(this.scenicSpot).length) {
      if (newScenes == 27) {
        this.handleServiceSelectItemDisabled(
          service,
          '场景',
          'scenes',
          27,
          true,
          'reset'
        )
      } else {
        this.handleServiceSelectItemDisabled(
          service,
          '场景',
          'scenes',
          27,
          true
        )
      }
    } else {
      this.handleServiceSelectItemDisabled(service, '场景', 'scenes', 27, false)
    }
  }

  /**将数据保存起来 */
  save = () => {
    // 格式化一下数据，过滤空值、加单位
    let serviceData = this.service.reduce((pre, curr) => {
      curr.childNodes.forEach(el => {
        // 过滤非必填的空值
        if (!el.required && !el.value) {
          return
        }
        pre[el.key] = el.value
        if (el.unitKey && el.unit) {
          pre[el.unitKey] = el.unit
        }
      })
      return pre
    }, {})

    // 内容数据
    const sessionService =
      this.propertyId == 6 && this.weddingPhotoType == 2
        ? {
            ...serviceData,
            age_begin: this.age_begin,
            age_end: this.age_end
          }
        : serviceData

    // 排序数据
    this.sessionServiceData = sessionService
    // 将服务内容数据存到stepTwoStore中  TODO  删除  存在当前store
    this.stepTwoStore.sessionService = sessionService

    // 删除模块的数据
    const sessionServiceSort = this.service.reduce((pre, curr, index) => {
      curr.childNodes.forEach(el => {
        if (el.key === 'ages') {
          pre['age_begin'] = index
          pre['age_end'] = index
        } else {
          pre[el.key] = index
        }
      })
      return pre
    }, {})
    this.sessionServiceSort = sessionServiceSort
    // 将服务内容的排序存到stepTwoStore中   TODO  删除  存在当前store
    this.stepTwoStore.sessionServiceSort = sessionServiceSort

    // 将服务内容的排序存到stepTwoStore中   TODO  删除  存在当前store
    this.stepTwoStore.sessionServiceDeleted = this.selectedParamDeleted

    // this.validateServiceData()
    this.stepTwoStore.setStepTwoData()
  }

  /** 检查服务内容必填项 */
  validateServiceData = () => {
    let errText = ''
    if (!this.service.length) {
      message.error('请填写服务内容')
      return false
    }
    const pass = this.service
      .reduce((pre, curr) => {
        if (curr.required) {
          pre = [...pre, ...curr.childNodes]
        }
        return pre
      }, [])
      .every(el => {
        if (!el.required || el.disabled) {
          return true
        } else if (el.type === 'inputInterval' && el.required) {
          // 目前只有婚纱摄影-儿童摄影下的适用年龄，先特殊处理。  历史遗留问题
          if (!this.age_begin || !this.age_end) {
            errText = `${el.text}未填写`
            return false
          }
          return true
        } else {
          if (el.type === 'selectInput' && el.required) {
            // 校验selectInput的信息完整性
            let errFlag = false
            const selectInputValue = el.value || []
            if (!selectInputValue.length) {
              errFlag = true
              errText = `${el.text}未填写`
            }
            selectInputValue.every(item => {
              const { id, extra } = item
              if (!id) {
                errFlag = true
                errText = `${el.text}存在未选择类型项`
                return false
              }
              if (extra !== 0 && !extra) {
                errFlag = true
                errText = `${el.text}存在未填写数量项`
                return false
              }
              return true
            })
            return !errFlag
          }

          if (el.type === 'radioInput' && el.required) {
            // 处理doubleInput
            const radioInputValue = el.value || {}
            const { id, title } = radioInputValue
            if (
              id === '' ||
              (id === '-1' && !title) ||
              (id === undefined && !title)
            ) {
              errText = `${el.text}未填写`
              return false
            }
          }

          if (el.type === 'doubleInput' && el.required) {
            // 校验doubleInput的信息完整性
            let errFlag = false
            const selectInputValue = el.value || []
            if (!selectInputValue.length) {
              errFlag = true
              errText = `${el.text}未填写`
            }
            selectInputValue.every(item => {
              const { title, extra } = item
              if (!title) {
                errFlag = true
                errText = `${el.text}存在未填写描述项`
                return false
              }
              if (extra !== 0 && !extra) {
                errFlag = true
                errText = `${el.text}存在未填写数量项`
                return false
              }
              return true
            })
            return !errFlag
          }

          if (el.key === 'man_modeling_combination') {
          }
          if (!errText && (el.value === undefined || el.value === '')) {
            errText = `${el.text}未填写`
          }
          return el.value !== undefined && el.value !== ''
        }
      })

    if (!pass) {
      message.error(errText)
      this.form && this.form.validateFieldsAndScroll()
    }

    return pass
  }

  checkArrayValue = (value, type) => {
    if (
      type == 'checkBox' &&
      Object.prototype.toString.call(value) == '[object Array]'
    ) {
      return value.reduce((acc, cur) => {
        if (cur && !acc.includes(cur + '')) {
          acc.push(cur + '')
        }
        return acc
      }, [])
    }
    return value
  }

  @action
  activation = index => {
    this.service = this.service.map((el, i) => {
      return {
        ...el,
        status: index === i
      }
    })
    this.handleServiceEditorPosition()
  }
  @action
  motivation = (type, index) => {
    if (index != 0 && type == 'up') {
      ;[this.service[index - 1], this.service[index]] = [
        this.service[index],
        this.service[index - 1]
      ]
    } else if (index != this.service.length - 1 && type == 'down') {
      ;[this.service[index + 1], this.service[index]] = [
        this.service[index],
        this.service[index + 1]
      ]
    }
    this.save()
    this.handleServiceEditorPosition()
  }
  @action
  getDeletedKey = () => {
    this.selectedParamDeleted = this.service
      .filter(el => !el.isShow)
      .reduce((acc, cur) => {
        cur.childNodes.forEach(el => (acc[el.key] = 1))
        return acc
      }, {})
  }

  @action
  discard = index => {
    const discardService = this.service[index]
    discardService.isShow = false
    discardService.status = false
    this.service.splice(index, 1)
    this.service.splice(this.service.length, 0, discardService)
    this.getDeletedKey()
    this.save()
  }
  @action
  addModal = index => {
    this.service[index].isShow = true
    this.getDeletedKey()
    this.save()
  }

  /**
   * @description 仅限婚戒首饰，在切换分类选择女戒或男戒的时候，清空女戒数据
   */
  @action
  clearWomanInfo = () => {
    const newService = cloneDeep(toJS(this.service))
    const ret = newService.map(item => {
      if (item.text === '女戒' || item.text === '其他') {
        return {
          ...item,
          childNodes: item?.childNodes?.map(el => ({
            ...el,
            value: undefined
          }))
        }
      }
      return item
    })
    this.service = ret
  }

  /**
   * @description 仅限婚戒首饰，在切换分类选择女戒或男戒的时候，清空男戒数据
   */
  @action
  clearManInfo = () => {
    const newService = cloneDeep(toJS(this.service))
    const ret = newService.map(item => {
      if (item.text === '男戒' || item.text === '其他') {
        return {
          ...item,
          childNodes: item?.childNodes?.map(el => ({
            ...el,
            value: undefined
          }))
        }
      }
      return item
    })
    this.service = ret
  }

  @action
  submitForm = formValue => {
    const value = cloneDeep(formValue)
    const newService = cloneDeep(toJS(this.service))

    // 整合value
    const newValue = Object.keys(value).reduce((pre, curr) => {
      const args = curr.split('-')
      const key = args[0]
      if (args.length === 1) {
        if (curr === 'age_begin') {
          this.age_begin = value[curr]
        } else if (curr === 'age_end') {
          this.age_end = value[curr]
        } else {
          pre[curr] = value[curr]
        }
      } else if (args.length === 3) {
        const [rootName, index, argValue] = args
        const type = newService
          .find(el => el.status)
          .childNodes.find(el => el.key === rootName).type
        if (type === 'selectInput') {
          if (pre[rootName]) {
            pre[rootName][+index] = pre[rootName][+index] || {}
            if (argValue === 'id') {
              pre[rootName][+index].id = value[curr]
              pre[rootName][+index].title = ''
            } else if (argValue === 'extra') {
              pre[rootName][+index].extra = value[curr]
              pre[rootName][+index].unit = value[curr] + '个'
            }
          } else {
            pre[rootName] = []
            pre[rootName][+index] = {}
            if (argValue === 'id') {
              pre[rootName][+index].id = value[curr]
              pre[rootName][+index].title = ''
            } else if (argValue === 'extra') {
              pre[rootName][+index].extra = value[curr]
              pre[rootName][+index].unit = value[curr] + '个'
            }
          }
        } else if (type === 'doubleInput') {
          if (pre[rootName]) {
            pre[rootName][+index] = pre[rootName][+index] || {}
            if (argValue === 'title') {
              pre[rootName][+index].id = 0
              pre[rootName][+index].title = value[curr]
            } else if (argValue === 'extra') {
              pre[rootName][+index].extra = value[curr]
              pre[rootName][+index].unit = value[curr] + '个'
            }
          } else {
            pre[rootName] = []
            pre[rootName][+index] = {}
            if (argValue === 'title') {
              pre[rootName][+index].id = 0
              pre[rootName][+index].title = value[curr]
            } else if (argValue === 'extra') {
              pre[rootName][+index].extra = value[curr]
              pre[rootName][+index].unit = value[curr] + '个'
            }
          }
        }
      } else if (args.length === 2) {
        pre[key] = {}
        pre[key][args[1]] = value[curr]
      }
      return pre
    }, {})

    // 重置
    newService
      .find(item => item.status)
      .childNodes.forEach(el => (el.value = ''))
    Object.keys(newValue).forEach(el => {
      if (el === 'age_begin' || el === 'age_end') {
        return
      }

      const findItem = newService
        .find(item => item.status)
        .childNodes.find(item => item.key == el || item.unitKey == el)

      if (findItem.key === el) {
        findItem.value = newValue[el]
      } else {
        // 修改单位
        findItem.unit = newValue[findItem.unitKey] || findItem.unit
      }
    })

    this.service = newService

    this.save()
  }
  @action
  handleChangeDisabledItem = state => {
    let newService = cloneDeep(toJS(this.service))
    newService = newService.map(el => {
      if (el.jewelry_type === 2) {
        el.childNodes = el.childNodes.map(item => {
          if (item.key === 'ring_cut' || item.key === 'ring_certificate') {
            item.disabled = state
          }
          return item
        })
      }
      return el
    })
    this.service = newService
  }

  @action
  handleOptionHidden = (keys, state) => {
    let newService = cloneDeep(toJS(this.service))
    newService = newService.map(el => {
      el.childNodes = el.childNodes.map(item => {
        if (keys.includes(item.key)) {
          item.disabled = state
        }
        return item
      })
      return el
    })
    this.service = newService
  }

  @action
  handleChangeDisabledOption = id => {
    let newService = cloneDeep(toJS(this.service))
    newService = newService.map(el => {
      const disabledOptionItem = el.childNodes.find(
        item => item.key === 'clothing' || item.key === 'man_clothing'
      )
      if (disabledOptionItem) {
        disabledOptionItem.disabledItem = id
      }
      return el
    })
    this.service = newService
  }

  @action
  handleChangeDataNode = (text, state) => {
    let newService = cloneDeep(toJS(this.service))
    newService = newService.map(el => {
      if (el.text == text) {
        el.isShow = state
      }
      return el
    })

    this.service = newService
  }

  /**
   * 计算编辑框的top值与左边对齐
   */
  // handleServiceEditorPosition = () => {
  //   setTimeout(() => {
  //     const selectedIndex = this.service.findIndex(item => item.status) // 选中的item的索引
  //     const sessionDomList = document.querySelectorAll(
  //       '#sessionServiceContainer>div'
  //     )
  //     const sessionDomBeforeSelectedList = Array.prototype.slice.call(
  //       sessionDomList,
  //       0,
  //       selectedIndex
  //     )
  //     const height = sessionDomBeforeSelectedList.reduce(
  //       (preHeight, session) => {
  //         return session.clientHeight + preHeight
  //       },
  //       0
  //     )
  //     const serviceEditor = document.querySelector('#setMeal-service-edit') //  编辑框
  //     if (serviceEditor) {
  //       serviceEditor.style.top = height + 88 + 'px'
  //       const editorScroll = serviceEditor.querySelector(
  //         '#setMeal-service-edit-scroll'
  //       )
  //       editorScroll.scrollTop = 0
  //     }
  //   }, 0)
  // }

  /**
   * 计算编辑框的top值与左边对齐
   */
  handleServiceEditorPosition = () => {
    setTimeout(() => {
      const sessionScrollWrapper = document.querySelector(
        '#sessionScrollWrapper'
      )
      const scrollTop = sessionScrollWrapper.scrollTop

      const serviceEditor = document.querySelector('#setMeal-service-edit') //  编辑框
      if (serviceEditor) {
        serviceEditor.style.top = scrollTop + 88 + 'px'
        const editorScroll = serviceEditor.querySelector(
          '#setMeal-service-edit-scroll'
        )
        editorScroll.scrollTop = 0
      }
    }, 0)
  }

  @action
  handleServiceSelectItemDisabled = (
    service,
    key,
    childKey,
    value,
    disabled,
    reset
  ) => {
    service.forEach(el => {
      if (el.key === key) {
        el.childNodes.forEach(child => {
          reset && (child['value'] = '')
          if (child.key === childKey) {
            child.options.forEach(v => {
              if (v.id === value) {
                v['disabled'] = disabled
              }
            })
          }
        })
      }
    })
  }

  // 版块二-旅拍相关-服务内容-行程
  @observable itineraryList = [] // 行程列表
  @observable destinationCityId // 目的地城市id

  /**
   * @title 请求，初始化行程数据
   */
  @action
  initItineraryList = list => {
    this.itineraryList = list
  }

  /**
   * @title 根据基础信息选中的额旅拍目的地城市，记录城市id，用于请求该城市下的景点
   */
  @action setDestinationCityId = id => (this.destinationCityId = id)

  /**
   * @title 修改行程内容项
   */
  @action
  changeItineraryList = (key, value, index) => {
    this.itineraryList[index][key] = value
  }

  /**
   * @title 新增行程
   */
  @action
  handleAddItinerary = () => {
    this.itineraryList.push({
      describe: '',
      spots: []
    })
  }

  /**
   * @title 删除行程
   */

  handleDeleteItinerary = index => {
    this.itineraryList.splice(index, 1)
  }
}
